<ng-container *ngIf="userLoggedIn$ | async; else loginPrompt">
  <ng-container *ngIf="isProductInWishlist(product) | async; else addItem">
    <button type="button"
            class="mb-product-line-wishlist-btn mb-1  mt-md-2 mt-lg-0"
            mbOneClickAllowed
            (click)="remove(product)"
            data-cy="mb-remove-from-wishlist"
            [ngbTooltip]="'pdpWishList.removeFromWishlist' | mbTranslate">
      <img src="../../../../../assets/icons/svg/wishlist-heart-filled.svg"
           title="Remove from favourites"
           alt="Remove from favourites"
           aria-label="Remove from favourites">
    </button>
  </ng-container>
  <ng-template #addItem>
    <button type="button"
            class="mb-product-line-wishlist-btn mb-1  mt-md-2 mt-lg-0"
            mbOneClickAllowed
            (click)="add(product)"
            data-cy="mb-add-to-wishlist"
            [ngbTooltip]="'pdpWishList.addToWishlist' | mbTranslate">
      <img src="../../../../../assets/icons/svg/wishlist-heart.svg"
           title="Add to favourites"
           alt="Add to favourites"
           aria-label="Add to favourites">
    </button>
  </ng-template>
</ng-container>
<ng-template #loginPrompt>
  <button class="mb-product-line-wishlist-btn mb-1  mt-md-2 mt-lg-0"
          (click)="navigateToLoginPage()"
          [ngbTooltip]="'pdpWishList.signInToWishlist' | mbTranslate"
          data-cy="mb-login-to-add-wishlist">
    <img src="../../../../../assets/icons/svg/wishlist-heart.svg"
         title="Sign in to add to favourites"
         alt="Sign in to add to favourites"
         aria-label="Sign in to add to favourites">
  </button>
</ng-template>


